import React, { useState } from "react";

import { Box, TextField, Typography } from "@mui/material";
import type { AICardConfig, CardConfig } from "store/types";

interface Props {
  config: AICardConfig;
  onUpdateConfig: (c: CardConfig) => void;
}

export const AISettings: React.FC<Props> = ({ config, onUpdateConfig }) => {
  const [localQuestion, setLocalQuestion] = useState(config.question);

  const handleBlur = () => {
    if (localQuestion !== config.question) {
      onUpdateConfig({ ...config, question: localQuestion, answer: undefined });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (localQuestion !== config.question) {
        onUpdateConfig({ ...config, question: localQuestion, answer: undefined });
      }
    }
  };

  return (
    <Box>
      <TextField
        fullWidth
        multiline
        rows={4}
        value={localQuestion}
        onChange={(e) => setLocalQuestion(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        placeholder="Enter your AI question here..."
        sx={{
          "& .MuiInputBase-input": { fontSize: 14, lineHeight: "20px" }
        }}
      />
      <Typography sx={{ fontSize: 11, color: "#9CA3AF", mt: 1 }}>
        Enter a question to ask the AI. The answer will be displayed on the card.
      </Typography>
    </Box>
  );
};
